module.exports = __webpack_public_path__ + "static/media/1.cb63cd81.jpg";